import { EVENTS } from 'util.events'

class CompleteTheSetForm extends HTMLElement {
    constructor() {
        super();
        this.button = this.querySelector('.product-complete-the-set__button');
        this.errorMessage = this.querySelector('.product-complete-the-set__error-message');

        if (this.button) {
            this.button.addEventListener('click', this.onAddAllToCart.bind(this));
        }
    }

    async onAddAllToCart(event) {
        event.preventDefault();

        if (this.button.classList.contains('loading')) return;

        this.setLoading(true);
        this.hideError();

        const rawVariantIds = this.button.getAttribute('data-variant-ids');
        let variantIds = [];

        try {
            variantIds = JSON.parse(rawVariantIds);
        } catch (e) {
            console.error('Invalid variant IDs format', e);
            this.showError('Unable to parse products to add to cart.');
            this.setLoading(false);
            return;
        }

        variantIds = variantIds.filter(id => id);

        if (variantIds.length === 0) {
            this.showError('No products available to add to cart.');
            this.setLoading(false);
            return;
        }

        const items = variantIds.map(id => ({
            id: id,
            quantity: 1
        }));

        try {
            const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    items: items,
                    sections: 'cart-ajax'
                })
            });

            const responseData = await response.json();

            if (response.ok) {
                // Dispatch native theme event to open ajax cart drawer
                this.dispatchEvent(
                    new CustomEvent(EVENTS.ajaxProductAdded, {
                        bubbles: true,
                        detail: {
                            product: responseData,
                            preventCartOpen: false
                        }
                    })
                );
            } else {
                this.showError(responseData.description || 'Failed to add items to cart.');
            }
        } catch (error) {
            console.error('Network Error:', error);
            this.showError('A network error occurred. Please try again.');
        } finally {
            this.setLoading(false);
        }
    }

    setLoading(isLoading) {
        if (isLoading) {
            this.button.classList.add('loading');
            this.button.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        } else {
            this.button.classList.remove('loading');
            this.button.querySelector('.loading-overlay__spinner').classList.add('hidden');
        }
    }

    showError(message) {
        if (this.errorMessage) {
            this.errorMessage.textContent = message;
            this.errorMessage.classList.remove('hidden');
        }
    }

    hideError() {
        if (this.errorMessage) {
            this.errorMessage.classList.add('hidden');
        }
    }
}

customElements.define('complete-the-set-form', CompleteTheSetForm);
